import styled from 'styled-components';

export const StyledCartTotalsWrapper = styled.div`
    padding: 20px;

    > div:last-child {
        padding-top: 10px;
    }
`;
